var _style, _g, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgJapan = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 42",
    style: {
      enableBackground: "new 0 0 64 42"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.jp_st0{fill:#FFFFFF;}\n\t.jp_st1{fill:#57A863;}\n\t.jp_st2{fill:#BE0026;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "black",
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 9.6,
    className: "jp_st0",
    width: 64,
    height: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "jp_st0",
    d: "M0,36.3c0,0.7,0.1,1.5,0.4,2.1h63.2c0.3-0.7,0.4-1.4,0.4-2.1v-1.1H0V36.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 22.4,
    className: "jp_st0",
    width: 64,
    height: 3.2
  }), /*#__PURE__*/React.createElement("rect", {
    y: 28.8,
    className: "jp_st0",
    width: 64,
    height: 3.2
  }), /*#__PURE__*/React.createElement("rect", {
    y: 16,
    className: "jp_st0",
    width: 64,
    height: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rounded_Rectangle_7_copy",
    className: "jp_st0",
    d: "M5.8,0h52.3C61.4,0,64,2.6,64,5.7v30.6c0,3.2-2.6,5.7-5.8,5.7H5.8 C2.6,42,0,39.4,0,36.3V5.7C0,2.6,2.6,0,5.8,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "jp_st1",
    d: "M64,5.3v31.4c0-0.1,0-0.3,0-0.4V5.7C64,5.6,64,5.5,64,5.3z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "jp_st2",
    cx: 32,
    cy: 21,
    r: 15.2
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgJapan, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Japan.58eeabd1.svg";
export { ForwardRef as ReactComponent };